import {
	VBtn,
	VCard,
	VCardText,
	VDialog,
	VIcon,
	VProgressLinear,
	VSpacer,
	VToolbar,
	VToolbarItems,
	VToolbarTitle
} from "vuetify/lib";

export default VDialog.extend( {
	name: "KFullscreenDialog",

	props: {
		bodyClasses: [ Array, Object, String ],

		fullWidth: {
			...VDialog.options.props.fullWidth,
			default: true
		},

		fullscreen: {
			...VDialog.options.props.fullscreen,
			default: true
		},

		hideOverlay: {
			...VDialog.options.props.hideOverlay,
			default: true
		},

		loading: Boolean,

		scrollable: {
			...VDialog.options.props.transition,
			default: true
		},

		title: String,

		transition: {
			...VDialog.options.props.transition,
			default: "dialog-bottom-transition"
		}
	},

	computed: {
		internalBodyClasses() {
			const classes = [ "pa-0", "fill-height" ];

			if ( Array.isArray( this.bodyClasses ) ) {
				classes.push( ...this.bodyClasses );
			} else if ( typeof this.bodyClasses === "object"
				|| typeof this.bodyClasses === "string"
			) {
				classes.push( this.bodyClasses );
			}

			return classes;
		}
	},

	methods: {
		genToolbar() {
			if ( !this.$scopedSlots.toolbar ) {
				return null;
			}

			return this.$scopedSlots.toolbar( {
				close: () => this.isActive = false
			} );
		},

		getContentSlot() {
			return [
				this.loading && <VProgressLinear
					backgroundColor="grey"
					class="ma-0"
					color="primary"
					height="3"
					indeterminate
					style="position: fixed; top: 0; z-index: 3;"
				></VProgressLinear>,

				<VCard tile>
					<VToolbar
						class="primary"
						dark
						flat
						tile
					>
						<VBtn icon onClick={() => this.isActive = false}>
							<VIcon>close</VIcon>
						</VBtn>

						<VToolbarTitle>{this.title}</VToolbarTitle>

						<VSpacer></VSpacer>

						<VToolbarItems>{this.genToolbar()}</VToolbarItems>

						<template slot="extension">
							{this.$slots.toolbarExtension}
						</template>
					</VToolbar>

					<VCardText class={this.internalBodyClasses}>
						{VDialog.options.methods.getContentSlot.call( this )}
					</VCardText>
				</VCard>
			];
		}
	}
} );
